import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-acknowledge-modal',
  templateUrl: './acknowledge-modal.component.html',
  styleUrls: ['./acknowledge-modal.component.css']
})
export class AcknowledgeModalComponent {
  @Input() headerText: string = 'Acknowledge';
  @Input() bodyText: string = '';
  @Input() closeButtonText: string = 'Close';

  constructor(
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit (): void {
  }

  closeModal () {
    this.ngbActiveModal.close();
  }
}